<div class="dialog-content-wrapper">
    <!-- TOPO FIXO -->
    <mat-toolbar class="toolbar-fixed" style="background-color: #00ACC1; color: white;">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <div class="contact-name">Pagamentos Pendentes</div>
            <button mat-icon-button (click)="dimiss()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <!-- CONTEÚDO SCROLLÁVEL -->
    <div class="dialog-scrollable-content">

        <form name="payPendingForm" [formGroup]="payPendingForm" class="generalInformation-edit w-100-p"
            fxLayout="column">

            <div fxLayout="row">
                <mat-form-field appearance="outline" fxFlex="30" class="mr-8">
                    <mat-label>Empresa</mat-label>
                    <input matInput [matAutocomplete]="autoCompany" formControlName="company" autocomplete="off"
                        type="search" />
                    <mat-autocomplete autoActiveFirstOption #autoCompany="matAutocomplete"
                        [displayWith]="displayCompanyFn">
                        <mat-option *ngFor="let company of companyList" [value]="company">
                            <p *ngIf="company.name">{{ company.name }}</p>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Período</mat-label>

                    <mat-date-range-input [rangePicker]="picker">
                        <input matStartDate placeholder="Data inicial" formControlName="start">
                        <input matEndDate placeholder="Data final" formControlName="end">
                    </mat-date-range-input>

                    <button mat-icon-button matSuffix
                        *ngIf="payPendingForm.get('start')?.value || payPendingForm.get('end')?.value"
                        (click)="cleanDateRange()" aria-label="Limpar datas">
                        <mat-icon>close</mat-icon>
                    </button>

                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>

            </div>

            <mat-divider></mat-divider>

            <mat-form-field *ngIf="typeControl.value == '1'" appearance="outline" fxFlex="15">
                <mat-label>Pesquisar</mat-label>
                <input matInput [formControl]="orderPayPendingForm" autocomplete="off" />
            </mat-form-field>

        </form>

        <div class="table-header">
            <div>Data</div>
            <div>Guia</div>
            <div>Paciente</div>
            <div>Status</div>           
            <div>Valor OS</div>
            <div>Valor Pago</div>
            <div>Usuário</div>
        </div>

        <mat-accordion>
            <mat-expansion-panel *ngFor="let item of orderPayPendingList">
                <mat-expansion-panel-header>
                    <div class="panel-row">
                        <div>{{ item.date | date : "dd/MM/yyyy" }}</div>
                        <div>{{ item.guideNumber }}</div>
                        <div>{{ item.patientName }}</div>
                        <div>{{ item.status }}</div>                        
                        <div>{{ item.value_os | currency : 'R$' }}</div>
                        <div>{{ item.value_pay | currency : 'R$' }}</div>
                        <div>{{ item.userName }}</div>
                        <div>
                            <button mat-icon-button (click)="navigateOs(item.patientId, item.orderId, $event)"
                                aria-label="Atendimento">                               
                                <mat-icon title="Visualizar Atendimento">receipt_long</mat-icon>
                            </button>
                        </div>
                    </div>
                </mat-expansion-panel-header>

                <div class="panel-detail">
                    <strong>Detalhes:</strong>
                    <p>ID: {{ item.orderId }}</p>
                    <p>Status: {{ item.status }}</p>
                    <p>Paciente: {{ item.patientName }}</p>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <!-- BASE FIXA -->
    <mat-paginator class="paginator-fixed" [length]="totalElements" [pageIndex]="pagina" [pageSizeOptions]="[10, 25]"
        showFirstLastButtons (page)="getOrderPayPending($event,'page')">
    </mat-paginator>
</div>